<template>
<gap top="single" bottom="single">
    <title-regular>Example:</title-regular>
    <row table="true">
        <column>
            <tpl :content="content"></tpl>
        </column>
        <column>
            <pre>{{ content }}</pre>
        </column>
    </row>
</gap>
</template>
<script>
export default {
    props: ['content'],
    components: {
        tpl: require('./tpl.vue').default,
        row: require('./row.vue').default,
        column: require('./column.vue').default,
        gap: require('./gap.vue').default,
        'title-regular': require('./title-regular.vue').default,
    },
}
</script>
